import { motion } from "framer-motion";

const fadeIn = (delay = 0) => ({
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-60px" },
    transition: { duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] },
});

const items = [
    {
        q: "Do I need a designer?",
        a: "No. Upload the artwork you already have and we check it against every screen's specs before it goes live. If a file needs adjusting we tell you exactly what to change.",
    },
    {
        q: "Can I change my mind after booking?",
        a: "Screens are held for you for 20 minutes at checkout — the meter only starts when you pay. Between booking and go-live you can swap creative or request date changes through your portal.",
    },
    {
        q: "What about GST and receipts?",
        a: "GST is added at checkout and shown as a separate line. A tax invoice and receipt are emailed automatically once payment clears — no chasing paperwork.",
    },
    {
        q: "Do I have to speak to someone?",
        a: "Only if you want to. Most bookings go end-to-end through the wizard. Bigger or custom campaigns get a campaign director on your account — reachable, not routed.",
    },
];

export const ObjectionHandler = () => {
    return (
        <section
            id="objections"
            data-testid="landing-objections"
            className="relative py-14 lg:py-20 border-t border-white/5"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <motion.div {...fadeIn(0)} className="max-w-3xl mb-12">
                    <div className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-[#FF5A00] mb-6 flex items-center gap-3">
                        <span className="inline-block w-6 h-px bg-[#FF5A00]" />
                        07 / You might be thinking
                    </div>
                    <h2 className="font-display font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                        Every objection<br />
                        <span className="text-slate-500">has a plain answer.</span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 border border-white/5">
                    {items.map((it, i) => (
                        <motion.div
                            key={it.q}
                            {...fadeIn(0.05 * i)}
                            data-testid={`landing-objection-${i}`}
                            className="bg-[#0F1E3B] p-8 lg:p-10"
                        >
                            <div className="font-display font-black text-lg lg:text-xl text-white leading-snug">
                                {it.q}
                            </div>
                            <div className="mt-4 text-sm text-slate-300 leading-relaxed">
                                {it.a}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
